import React, { useContext } from 'react'
import styled from 'styled-components'
import theme from '@shared/utils/theme'
import Icon from '@shared/components/Icon'
import PageLayout from '../../components/PageLayout'
import { SimulationContext } from './SimulationPage'
import { get } from 'lodash'
import { createRecord } from '../../services/record-services'
import Button from '../../components/Button'
import { Comment } from '@shared/components/Text'
import { AppContext } from '../../Context'

const SimulationSuccessContainer = styled(PageLayout)`
  color: ${ theme.palette.black };
  padding: 0 20px;
  align-items: center;
  .content{
    > a {
      text-decoration: underline;
    }
   svg {
      fill: ${ theme.palette.green };
      margin-right: 20px;
    }
    .title{
      font-size: 20px;
      font-weight: bold;
      display: flex;
      align-items: center;
      margin: 20px 0;
    }
  }
  .faq-link {
    text-decoration: underline;
  }
  .submit {
    margin-bottom: 15px;
    margin-top: 40px;
  }
`

export default function SimulationSuccess({ ...props }) {
  const { employee } = useContext(AppContext)
  const { parentHistory, simulation, simulationOnly} = useContext(SimulationContext)
  const submitTxt = !simulationOnly ? 'Je dépose un dossier' : 'Retour à l’accueil'

  const openFaq = () => {
    parentHistory('/faq')
    return true
  }

  const onSubmit = () => {
    if (!simulationOnly) {
      return createRecord(simulation)
      .then(result => {
        if (get(result, 'data.createRecord._id')) {
          parentHistory('/record/' + get(result, 'data.createRecord._id'))
          return true
        }
      })
    } else {
      parentHistory('/')
    }
  }

  return (
    <SimulationSuccessContainer>
      <Icon name="check_circle"/>
      <div className="title">
        Vous êtes éligible à l’allocation frais de garde d’enfant(s)
      </div>
      <div>
        {
          simulationOnly ?
            (employee && employee.nbChildren === 0 ? `Lorsque votre enfant sera déclaré auprès de votre gestion RH, vous pourrez accéder au formulaire d’ouverture de droits` : '') :
            `Vous avez accès au formulaire de demande où des pièces justificatives seront à télécharger.`
        }
        <br/>
        { simulationOnly ? 'N’oubliez pas de déclarer votre enfant auprès de votre gestion RH afin d’accéder au formulaire de demande.' : ''}
        <br/>
        { simulationOnly ? `Pour en savoir plus sur les montants de l’allocation, veuillez cliquer sur le lien suivant :` :
          `Pour en savoir plus sur la liste des pièces justificatives à fournir, veuillez cliquer sur le lien suivant : `}
        <div className="faq-link" onClick={ openFaq }>J'ai une question ?</div>
      </div>
      <div>
        <Button className="submit" onClick={onSubmit}>{ submitTxt }</Button>
      </div>
      {
        !simulationOnly && <Comment>Un dossier est à constituer pour chaque enfant et pour chaque mode de garde différent (Crèche, Assistance maternelle, etc.)</Comment>
      }
    </SimulationSuccessContainer>
  )
}
